import { Clock, IndianRupee, Star } from "lucide-react";
import StatusBadge from "./StatusBadge.jsx";
import { formatDate } from "./bookingUtils.jsx";

export default function History({ history }) {
    return (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-slate-100 bg-slate-50/80 text-left text-xs font-medium uppercase tracking-wide text-slate-500">
                            <th className="px-4 py-3">Mentor / Course</th>
                            <th className="px-4 py-3">Date & Time</th>
                            <th className="px-4 py-3">Price</th>
                            <th className="px-4 py-3">My Rating</th>
                            <th className="px-4 py-3">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((h) => (
                            <tr key={h.id} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60 transition-colors">
                                <td className="px-4 py-3">
                                    <div className="flex items-center gap-3">
                                        <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-xs font-semibold text-white">
                                            {h.initials}
                                        </div>
                                        <div>
                                            <p className="font-medium text-slate-900">{h.mentorName}</p>
                                            <p className="text-xs text-slate-400">{h.course}</p>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-4 py-3 text-slate-600">
                                    <p>{formatDate(h.date)}</p>
                                    <p className="flex items-center gap-1 text-xs text-slate-400">
                                        <Clock className="h-3 w-3" /> {h.time}
                                    </p>
                                </td>
                                <td className="px-4 py-3">
                                    <span className="flex items-center font-semibold text-indigo-600">
                                        <IndianRupee className="h-3.5 w-3.5" />
                                        {h.price.toLocaleString("en-IN")}
                                    </span>
                                </td>
                                <td className="px-4 py-3">
                                    {h.myRating ? (
                                        <span className="flex items-center gap-1 font-medium text-slate-700">
                                            <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> {h.myRating}
                                        </span>
                                    ) : (
                                        <span className="text-xs text-slate-300">—</span>
                                    )}
                                </td>
                                <td className="px-4 py-3">
                                    <StatusBadge status={h.status} />
                                </td>
                            </tr>
                        ))}

                        {history.length === 0 && (
                            <tr>
                                <td colSpan={5} className="px-4 py-10 text-center text-sm text-slate-400">
                                    No past orders match your search.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}